import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { InfoSheetModalOptions } from '../../models/InfoSheetModal.model';

@Component({
    selector: 'app-info-sheet-modal',
    templateUrl: './info-sheet-modal.page.html',
    styleUrls: ['./info-sheet-modal.page.scss']
})
export class InfoSheetModalPage implements OnInit {

    @Input() config!: InfoSheetModalOptions;

    constructor(
        private modalCtrl: ModalController
    ) { }

    ngOnInit(): void { }

    /**
     * Cierra el modal
     */
    public onClose = () => this.modalCtrl.dismiss();
}
